export enum MainRoutes {
  HOME = '/',
  LOGIN = '/login',
  SSO = '/sso',
  NEW_PASSWORD = '/newpassword',
  PROFILE = '/profile',
  QUEUE = '/queue',
  DASHBOARD = '/dashboard',
  RECENTLY_VIEWED_PATIENTS = '/recentlyviewedpatients',
  REPORTING = '/reporting',
  ADMIN = '/admin',
  ENTITIES = '/entities',
  REVIEWS = '/reviews',
  RR_REVIEWS = '/rr-reviews',
  TEAM = '/team',
  USER = '/user',
  FEATURE = '/feature',
  SEARCH = '/search',
  CMS = '/cms',
  RR = '/rr',
  MESSAGE_CENTER = '/message-center',
}

export enum SubRoutes {
  TEAMS = '/teams',
  RULES = '/rules',
  CONTACTS = '/contacts',
  PATIENTS = '/patients',
  ADMISSIONS = '/admissions',
  CHART = '/chart',
  ENTITIES = '/entities',
  REVIEWS = '/reviews',
  VIEW_AND_DO = '/viewanddo',
}

export enum RouteParams {
  TEAM_ID = '/:teamId',
  ENTITY_ID = '/:entityid',
  PATIENT_ID = '/:patientid',
  ADMISSION_ID = '/:admissionid',
  ENTITY_ID_1 = '/:entityId',
  ADMISSION_ID_1 = '/:admissionId',
  TEAM_ID_1 = '/:teamid',
  USER_NAME = '/:username',
  FEATURE_ID = '/:featureid',
  PATIENT_ID_1 = '/:patientId',
  REVIEW_ID = '/:reviewId',
  TAB_INDEX = '/:tabIndex',
}

export const PATHS = {
  HOME: `${MainRoutes.HOME}`,
  LOGIN: `${MainRoutes.LOGIN}`,
  SSO: `${MainRoutes.SSO}`,
  NEW_PASSWORD: `${MainRoutes.NEW_PASSWORD}`,
  PROFILE: `${MainRoutes.PROFILE}`,
  QUEUE: `${MainRoutes.QUEUE}`,
  TEAMS_QUEUE: `${MainRoutes.QUEUE}${SubRoutes.TEAMS}${RouteParams.TEAM_ID}`,
  DASHBOARD: `${MainRoutes.DASHBOARD}`,
  RECENTLY_VIEWED_PATIENTS: `${MainRoutes.RECENTLY_VIEWED_PATIENTS}`,
  REPORTING: `${MainRoutes.REPORTING}`,
  ADMIN: `${MainRoutes.ADMIN}`,
  ENTITY_RULES: `${MainRoutes.ENTITIES}${RouteParams.ENTITY_ID}${SubRoutes.RULES}`,
  ENTITY_CONTACTS: `${MainRoutes.ENTITIES}${RouteParams.ENTITY_ID}${SubRoutes.CONTACTS}`,
  ADMISSION_REVIEWS: `${MainRoutes.REVIEWS}${RouteParams.ENTITY_ID}${RouteParams.PATIENT_ID}${RouteParams.ADMISSION_ID}`,
  ADMISSION_RR_REVIEWS: `${MainRoutes.RR_REVIEWS}${RouteParams.ENTITY_ID_1}${RouteParams.ADMISSION_ID_1}`,
  TEAM: `${MainRoutes.TEAM}${RouteParams.TEAM_ID_1}`,
  USER: `${MainRoutes.USER}`,
  USER_NAME: `${MainRoutes.USER}${RouteParams.USER_NAME}`,
  FEATURES: `${MainRoutes.FEATURE}`,
  FEATURE: `${MainRoutes.FEATURE}${RouteParams.FEATURE_ID}`,
  SEARCH: `${MainRoutes.SEARCH}`,
  CMS: `${MainRoutes.CMS}`,
  ENTITY_CHART: `${MainRoutes.ENTITIES}${RouteParams.ENTITY_ID_1}${SubRoutes.PATIENTS}${RouteParams.PATIENT_ID_1}${SubRoutes.ADMISSIONS}${RouteParams.ADMISSION_ID_1}${SubRoutes.CHART}`,
  RR_ENTITY_CHART: `${MainRoutes.RR}${SubRoutes.ENTITIES}${RouteParams.ENTITY_ID_1}${SubRoutes.ADMISSIONS}${RouteParams.ADMISSION_ID_1}${SubRoutes.CHART}`,
  REVIEW: `${MainRoutes.ENTITIES}${RouteParams.ENTITY_ID_1}${SubRoutes.PATIENTS}${RouteParams.PATIENT_ID_1}${SubRoutes.ADMISSIONS}${RouteParams.ADMISSION_ID_1}${SubRoutes.REVIEWS}${RouteParams.REVIEW_ID}`,
  RR_REVIEW: `${MainRoutes.RR}${SubRoutes.ENTITIES}${RouteParams.ENTITY_ID_1}${SubRoutes.ADMISSIONS}${RouteParams.ADMISSION_ID_1}${SubRoutes.REVIEWS}${RouteParams.REVIEW_ID}`,
  VIEW_AND_DO: `${MainRoutes.ENTITIES}${RouteParams.ENTITY_ID_1}${SubRoutes.ADMISSIONS}${RouteParams.ADMISSION_ID_1}${SubRoutes.VIEW_AND_DO}${RouteParams.TAB_INDEX}`,
  MESSAGE_CENTER: `${MainRoutes.MESSAGE_CENTER}`,
} as const;
